module.exports = __webpack_public_path__ + "media/Images/icon-comment-dollar-o-83a035d114ba4a40dfa5cdf726cc1d56.svg";